import { render } from "./InitiativeList.vue?vue&type=template&id=d20aea5c&scoped=true"
import script from "./InitiativeList.vue?vue&type=script&lang=js"
export * from "./InitiativeList.vue?vue&type=script&lang=js"

import "./InitiativeList.vue?vue&type=style&index=0&id=d20aea5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20aea5c"]])

export default __exports__